import { CalendarCheck, ChartNoAxesColumnIncreasing, Clock, Users } from "lucide-react";
import { PageHero } from "@/components/ui/PageHero";
import { buttonClass } from "@/components/ui/buttonStyles";
import { useAppTranslation } from "@/i18n/useAppTranslation";
import { scrollToSectionIdWhenReady } from "@/utils/smoothScroll";

const VALUES = [
  { icon: ChartNoAxesColumnIncreasing, key: "valueStrategic" },
  { icon: CalendarCheck, key: "valueReady" },
  { icon: Clock, key: "valueTime" },
  { icon: Users, key: "valueServices" },
] as const;

export function ResourcesHero({ crumb }: { crumb: string }) {
  const { t } = useAppTranslation("resourcesPage");

  return (
    <PageHero
      crumb={crumb}
      title={
        <>
          {t("heroTitleLead")}{" "}
          <em className="font-medium italic text-teal-strong">{t("heroTitleAccent")}</em>
        </>
      }
      lead={<p>{t("heroLead")}</p>}
      actions={
        <a
          href="#catalogo"
          onClick={(e) => {
            e.preventDefault();
            window.history.replaceState(null, "", "#catalogo");
            scrollToSectionIdWhenReady("catalogo");
          }}
          className={buttonClass("primary", "lg")}
        >
          {t("heroCta")}
        </a>
      }
    >
      <ul
        aria-label={t("valuesLabel")}
        className="hero-rise mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-brand-primary/8 pt-8 sm:grid-cols-4"
        style={{ ["--delay" as string]: "240ms" }}
      >
        {VALUES.map(({ icon: Icon, key }) => (
          <li key={key} className="flex flex-col gap-2 text-sm font-medium leading-snug text-ink-soft">
            <span className="grid size-10 place-items-center rounded-full bg-teal-soft text-teal-strong">
              <Icon className="size-5" strokeWidth={1.75} aria-hidden="true" />
            </span>
            {t(key)}
          </li>
        ))}
      </ul>
    </PageHero>
  );
}
